import React, {useState, useEffect} from 'react';
import { Row, Col, Button, InputGroup } from 'react-bootstrap';
import MainMenu from '../../components/MainMenu';
import '../../Global/styleGeral.css';
import Listagem from '../../components/Listagens';
import {colunaEventosCancelados} from '../../components/Listagens/colunas';
import api from '../../services/api'
import {AlertGeral, requisitarAPI} from '../../components/AlertGeral';
import Spinner from '../../components/Spiner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

const EventosCancelados = ({ history, match}) => {
  const [retorno, setRetorno] = useState({});
  const [loading, setLoading] = useState(true);
  const [eventos, setEventos] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(90, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const tipo = match.params.tipo;

  async function getDados() {
    const status = ['C']; //cancelados

    setLoading(true);
    const ret = await requisitarAPI(
      () => api.get(`${tipo}/agenda/${status}`, { params: { periodo_inicio: startDate, periodo_fim: endDate } }),
      'Falha ao obter dados do servidor'
    );
    setRetorno(ret);

    if (!ret.erro) {
      const dados = ret.response.data;
      setEventos(Array.isArray(dados) ? dados : dados.calendar || []);
    }

    setLoading(false);
  }

  useEffect(() => {
    getDados();
  },[]);

  return (
    <>
      <MainMenu navigation={history} />


      <div className="titulo-pagina">Eventos Cancelados
      <a href="/ajuda" alt="Clique para acessar página de ajuda" style={{ float:"right" }} title="Clique para acessar página de ajuda"><FontAwesomeIcon className="icone" icon={faQuestionCircle}/></a>

          <AlertGeral retorno={retorno} />
          <Spinner loading={loading} />
      </div>

      <div className="container-principal">
        <Row>
          <Col className="mb-3" sm={12} md={6} lg={3}>
            <InputGroup>
              <input
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                type="date"
                className="form-control"
              />
            </InputGroup>
          </Col>
          <Col className="mb-3" sm={12} md={6} lg={3}>
            <InputGroup>
              <input
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                type="date"
                className="form-control"
              />
            </InputGroup>
          </Col>
          <Col className="mb-3">
            <Button variant="outline-secondary" onClick={getDados}>
              Filtrar
            </Button>
          </Col>
        </Row>
        <Row>
          <Listagem
            dados={eventos}
            cols={colunaEventosCancelados}
            botaoExtra={{title:"Visualizar", icone:"eye", page:`eventosCancelados/view/${tipo}`}}
            noEdit
            noCancel
            history={history}
            />
        </Row>
      </div>
    </>
  )
}

export default EventosCancelados;
